
export { getMinifiedCarrier } from "./contentfulAPI/carrier.fetchers"